/* ============================================================
 * Naive UI 全局 locale 配置
 *
 * 由 App.vue 的 <NConfigProvider> 统一注入，全站继承 zhCN。
 * 未来 i18n 切换：把 zhCN/dateZhCN 替换成 enUS/dateEnUS 即可。
 * ============================================================ */

import { dateZhCN, zhCN, type NLocale, type NDateLocale } from 'naive-ui'

export const naiveLocale: NLocale = zhCN
export const naiveDateLocale: NDateLocale = dateZhCN